import React, { useCallback, useState } from 'react'
import { Typography } from 'antd'
import fileDownload from 'js-file-download'

import { Panel } from '../../../core/components/styled'

import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks/effects'

import { MENU_TYPE_OPTIONS, PERIOD_OPTIONS } from '../../constants'
import {
  generateMenuDistributionAgeReport,
  generateMenuPublicationAgeReport,
} from '../../rest'
import {
  MenuDistributionAgeReportForm,
  MenuPublicationAgeReportForm,
} from '../forms'

const MenuAgeReportPage = () => {
  useDocumentTitle('Reports - Menu Age')
  const [
    isGeneratingPublicationReport,
    setIsGeneratingPublicationReport,
  ] = useState(false)
  const [
    isGeneratingDistributionReport,
    setIsGeneratingDistributionReport,
  ] = useState(false)

  const generatePublicationReport = useCallback(
    async ({ dateRange, menuType }) => {
      try {
        setIsGeneratingPublicationReport(true)
        const [startDateMoment, endDateMoment] = dateRange
        const reportResponse = await generateMenuPublicationAgeReport({
          startDate: startDateMoment.format('YYYY-MM-DD'),
          endDate: endDateMoment.format('YYYY-MM-DD'),
          menuType,
        })
        fileDownload(reportResponse.data, 'MenuPublicationAgeReport.csv')
        setIsGeneratingPublicationReport(false)
      } catch (error) {
        showErrorNotification({
          message: 'Failed to generate report.',
          description: error.response?.statusText,
        })
        setIsGeneratingPublicationReport(false)
      }
    },
    [],
  )

  const generateDistributionReport = useCallback(
    async ({ menuType, period }) => {
      try {
        setIsGeneratingDistributionReport(true)
        const reportResponse = await generateMenuDistributionAgeReport({
          menuType,
          period,
        })
        fileDownload(reportResponse.data, 'MenuDistributionAgeReport.csv')
        setIsGeneratingDistributionReport(false)
      } catch (error) {
        showErrorNotification({
          message: 'Failed to generate report.',
          description: error.response?.statusText,
        })
        setIsGeneratingDistributionReport(false)
      }
    },
    [],
  )

  return (
    <div>
      <Panel margin="small no">
        <Typography.Title level={4}>Distribution</Typography.Title>
      </Panel>
      <MenuDistributionAgeReportForm
        onSubmit={generateDistributionReport}
        isGeneratingReport={isGeneratingDistributionReport}
        menuTypeOptions={MENU_TYPE_OPTIONS}
        periodOptions={PERIOD_OPTIONS}
      />
      <Panel margin="small no">
        <Typography.Title level={4}>Publication</Typography.Title>
      </Panel>
      <MenuPublicationAgeReportForm
        onSubmit={generatePublicationReport}
        isGeneratingReport={isGeneratingPublicationReport}
        menuTypeOptions={MENU_TYPE_OPTIONS}
      />
    </div>
  )
}

export default MenuAgeReportPage
